export default {
  FileNameType: {
    sample: 'Coolant Sample',
    icp: 'Coolant ICP',
    ic: 'Coolant Advanced IC'
  }
};
